import React from 'react';
import styled from "styled-components";

const size = {
  mobileS: '320px',
  mobileM: '375px',
  mobileL: '652px',
  tablet: '1021px',
  laptop: '1022px',
  laptopL: '1440px',
  desktop: '2560px'
}

export const device = {
  mobileS: `(min-width: ${size.mobileS})`,
  mobileM: `(min-width: ${size.mobileM})`,
  mobileL: `(max-width: ${size.mobileL})`,
  tablet: `(max-width: ${size.tablet})`,
  laptop: `(min-width: ${size.laptop})`,
  laptopL: `(min-width: ${size.laptopL})`,
  desktop: `(min-width: ${size.desktop})`,
  desktopL: `(min-width: ${size.desktop})`
};

export const StyledTable = styled.table`
  width: 100%;
  border: 2px solid #E2E5E8;
  
  @media ${device.tablet} { 
    .tc-row {
      display: flex;
      flex-direction: column;
      justify-content: center;
      
      #tc-name, #tc-email, #tc-date, #tc-id {
        padding-left: 8rem;
        font-size: 2.2rem;
      }
      
      .customer-label {
        width: 8rem;
        position: absolute;
        transform: translate(-60px, -1px);
      }
    }
  }
  
  @media ${device.tablet} { 
    .tc-row {
      display: flex;
      flex-direction: column;
      justify-content: center;
      margin-left: auto;
      
      #tc-name, #tc-email, #tc-date, #tc-id {
        padding-left: 8rem;
        font-size: 2.2rem;
      }
      
      .customer-label {
        width: 8rem;
        position: absolute;
        transform: translate(-60px, -1px);
      }
    }
  }
    
  @media ${device.laptop} {
    .tc-row {
      .customer-label {
        display: none;
      }
    }
    
    #tc-name {
      width: 16rem;
    }
    
    #tc-email {
      width: 35rem;
    }
    
    #tc-date {
      width: 10rem;
    }
    
    #tc-id {
      width: 32rem;
    }
    
    .table-header {
      .th-Name {
        width: 16rem;
      }
  
      .th-Email {
        width: 35rem;
      }
      
      .th-Created {
        width: 10rem;
      }
      
      .th-ID {
        width: 32rem;
      }
    }
  }
  
  @media ${device.laptopL} { 
    #tc-name {
      width: 32rem;
    }
    
    #tc-email {
      width: 50rem;
    }
    
    #tc-date {
      width: 14rem;
    }
    
    #tc-id {
      width: 40rem;
    }
    
    .table-header {
      .th-Name {
        width: 32rem;
      }
      
      .th-Email {
        width: 50rem;
       }
      
      .th-Created {
        width: 14rem;
      }
      
      .th-ID {
        width: 40rem;
        padding-left: 2rem;
      }
    }
  }
`

export const TableHeader = styled.div`
  color: black;
  background-color: #FFFFFF;
  border-bottom: 2px solid #E2E5E8;
  padding: 3rem 4rem;
  display: flex;
  justify-content: space-evenly;

  th {
    font-size: 2rem;
    width: 100%;
    text-align: left;
  }
  
  th.small {
   width: 50%;
  }
`

export const TableRow = styled.div`
  color: black;
  background-color: ${(props) => props.index % 2 === 0 ? '#FAFAFA' :'#F3F6F9'};
  ${(props) => props.cursor && `cursor: ${props.cursor}`};
  padding: 3rem 4rem;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  :hover {
    background-color: #0f82c5;
    color: white;
  }
`

export const TableCell = styled.tr`
  width: ${(props) => props.width ? `${props.width}` :'100%'};
  font-size: 2rem;
  font-family: ${(props) => props.fontFamily ? props.fontFamily : 'inherit'};
  text-align: ${(props) => props.textAlign ? props.textAlign : 'left'};
  padding: ${(props) => props.padding ? props.padding : 0}
  border: 1px dashed red;
`